import React, { useEffect, useState } from "react";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { Box, Button, CircularProgress, Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { color } from "../../../../StyleData/Config";
import { Clear, DeleteOutlined, Domain, EditOutlined, PrintOutlined } from "@mui/icons-material";
import NormalTable from "../../../../Component/NormalTable";
import CreatePart from "./CreatePart";
import { toast } from "react-toastify";
import { printReservationForm } from "../../../../Component/printWorkOrder";
import { usePrintLoader } from "../../../../Component/usePrintLoader";
import { woStatus as WO_STATUS, partsReservationStatus } from "../../../../ConfigInfo/Info";

import ResponsiveDialog from "../../../../Component/ResponsiveDialog";
const Partlist = ({ workOrderId, enableDisable, woStatus, refreshWoStatus, printName }) => {
  const [partList, setPartList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [partDialogue, setPartDialogue] = useState(false);
  const [editData, setEditData] = useState(null);
  const [viewDialogue, setViewDialogue] = useState(false);
  const [viewItems, setViewItems] = useState([]);
  const [viewCode, setViewCode] = useState("");
  const [viewReservationId, setViewReservationId] = useState(null);
  const [viewStatus, setViewStatus] = useState("");
  const { runPrint, PrintLoader } = usePrintLoader();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      let getPartlistlink = masterAPI["partsReservation"].getByWorkOrderId;
      let response = await axiosPrivate.get(`${getPartlistlink}/${workOrderId}`);

      setPartList(Array.isArray(response.data.result) ? response.data.result : []);
    } catch (error) {
      setPartList([]);
    }
    setLoading(false);
  };

  const handleCodeClick = (row) => {
    setViewItems(row.partsReservationItemsList || []);
    setViewCode(row.code);
    setViewReservationId(row.id);
    setViewStatus(row.status?.toUpperCase());
    setViewDialogue(true);
  };

  const confirmAction = (onConfirm) => {
    toast(
      <Grid>
        <Typography sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}>Are you sure you want to delete?</Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                onConfirm();
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      }
    );
  };

  const confirmReleasePart = (item) => confirmAction(() => handleReleasePart(item));

  const confirmReleaseReservation = (reservation) =>
    confirmAction(() => handleReleaseReservation(reservation.id));

  const handleReleasePart = async (item) => {
    const releaseLink = masterAPI["partsReservation"].release;
    const payload = {
      partsReservationId: viewReservationId,
      partId: item.partsId,
      stockRoomId: item.stockRoomId,
    };
    await axiosPrivate
      .put(`${releaseLink}`, payload)
      .then(() => {
        setViewItems((prev) =>
          prev.filter(
            (i) => !(i.partsId === item.partsId && i.stockRoomId === item.stockRoomId)
          )
        );
        getData();
      })
      .catch((e) => {
        console.log(e, "release part error");
      });
  };

  // Releases the whole reservation via the same API used for a single item,
  // sending only the reservation id.
  const handleReleaseReservation = async (reservationId) => {
    const releaseLink = masterAPI["partsReservation"].release;
    const payload = { partsReservationId: reservationId };
    await axiosPrivate
      .put(`${releaseLink}`, payload)
      .then(() => {
        getData();
      })
      .catch((e) => {
        console.log(e, "release reservation error");
      });
  };

  const itemColumns = [
    {
      Header: "Part Code",
      accessor: "partCode",
    },
    {
      Header: "Part Name",
      accessor: "partName",
    },
    {
      Header: "Stock Room",
      accessor: "stockRoomName",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
    {
      Header: "Actions",
      Cell: ({ row }) => {
        const deleteDisabled =
          viewStatus !== partsReservationStatus.RFE && viewStatus !== partsReservationStatus.OPEN;
        return (
          <IconButton disabled={deleteDisabled} onClick={() => confirmReleasePart(row.original)}>
            <DeleteOutlined
              sx={{
                fontSize: color.masterEditDelButton,
                color: deleteDisabled ? "default" : color.masterEditDelButtonColor,
              }}
            />
          </IconButton>
        );
      },
      disableFilters: true,
    },
  ];

  const getStatusName = (status) => {
  switch (status?.toUpperCase()) {
    case partsReservationStatus.PPRAPPR:
      return "Pending Part Reservation Approval";

    case partsReservationStatus.REJT:
      return "Rejected";

    case partsReservationStatus.RFE:
      return "Ready for Execution";

    case partsReservationStatus.OPEN:
      return "Open";

    default:
      return status || "---";
  }
};

  const partsColumns = [
    {
      Header: "Code",
      accessor: "code",
      Cell: ({ row }) => (
        <Typography
          sx={{
            color: "#0d6efd",
            fontSize: "inherit",
            fontWeight: 600,
            cursor: "pointer",
          }}
          onClick={() => handleCodeClick(row.original)}
        >
          {row.original.code}
        </Typography>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => (
    <Typography sx={{ color: "inherit", fontSize: "inherit", fontWeight: "inherit" }}>
      {getStatusName(row.original.status)}
    </Typography>
  ),
    },
    {
      Header: "Remarks",
      accessor: "comments",
      Cell: ({ row }) =>
        row.original.status?.toUpperCase() === partsReservationStatus.REJT
          ? row.original.comments || "---"
          : "---",
    },
    // {
    //   Header: "Current Work Flow",
    //   accessor: "currentWorkFlow",
    // },
    {
      Header: "Actions",
      Cell: ({ row }) => {
        const editStatus = row.original.status?.toUpperCase();
        const editDisabled =
          (editStatus !== partsReservationStatus.PPRAPPR && editStatus !== partsReservationStatus.REJT && editStatus !== partsReservationStatus.OPEN) ||
          woStatus?.toUpperCase() === WO_STATUS.CLOSE;
          // enableDisable?.part?.edit === false;
        const deleteDisabled =
          (editStatus !== partsReservationStatus.RFE && editStatus !== partsReservationStatus.OPEN) ||
          woStatus?.toUpperCase() === WO_STATUS.CLOSE;
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              disabled={editDisabled}
              onClick={() => {
                setEditData(row.original);
                setPartDialogue(true);
              }}
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: editDisabled ? "default" : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
            <IconButton
              disabled={deleteDisabled}
              onClick={() => confirmReleaseReservation(row.original)}
            >
              <DeleteOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: deleteDisabled ? "default" : color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handlePartClose = () => {
    setPartDialogue(false);
    setEditData(null);
    getData();
    if (refreshWoStatus) refreshWoStatus();
  };

  const showPartIcon = woStatus?.toUpperCase() !== WO_STATUS.PPRAPPR;

  return (
    <>
      {loading ? (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}><CircularProgress /></Box>
      ) : (
        <Grid container gap={"1rem"}>
          <Grid item xs={12} sx={{ boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)", p: 1.5, backgroundColor: "white" }}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "0.75rem",
                mb: "0.5rem",
              }}
            >
              <Typography sx={{ color: color.masterDialogTitleColor, fontSize: { xs: "0.95rem", sm: color.masterDialogFontSize } }}>
                Part
              </Typography>
              <Box sx={{ display: "flex", gap: "0.5rem" }}>
                <Tooltip title="Print Reservation ">
                  <span>
                    <IconButton
                      size="small"
                      disabled={partList.length === 0}
                      onClick={() =>
                        runPrint(printReservationForm, workOrderId, printName,false)
                      }
                    >
                      <PrintOutlined sx={{ fontSize: { xs: "1.4rem", sm: "1.7rem" } }} />
                    </IconButton>
                  </span>
                </Tooltip>
                {showPartIcon && (
                  <Tooltip title="Parts">
                    <span>
                      <IconButton
                        size="small"
                        disabled={enableDisable?.part?.create === false}
                        onClick={() => setPartDialogue(true)}
                      >
                        <Domain sx={{ fontSize: { xs: "1.4rem", sm: "1.7rem" } }} />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Box>
            </Box>
            <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
            <Box sx={{ overflowX: "auto" }}>
              <NormalTable columns={partsColumns} data={partList} />
            </Box>
          </Grid>
        </Grid>
      )}
      <ResponsiveDialog
        open={partDialogue}
        onClose={handlePartClose}
        fullWidth
        maxWidth={"lg"}
      >
        <CreatePart handleCloseClick={handlePartClose} workOrderId={workOrderId} editData={editData} />
      </ResponsiveDialog>
      <ResponsiveDialog
        open={viewDialogue}
        onClose={() => setViewDialogue(false)}
        fullWidth
        maxWidth={"md"}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "0.5rem" }}>
            <Typography sx={{ color: color.masterDialogTitleColor, fontSize: color.masterDialogFontSize }}>
              Part List {viewCode ? `- ${viewCode}` : ""}
            </Typography>
            <IconButton onClick={() => setViewDialogue(false)}>
              <Clear />
            </IconButton>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
          <Box sx={{ overflowX: "auto" }}>
            <NormalTable columns={itemColumns} data={viewItems} />
          </Box>
        </Box>
      </ResponsiveDialog>
      {PrintLoader}
    </>
  );
};

export default Partlist;
